module.exports = __webpack_public_path__ + "static/media/galerija_2022_0033.d5cf873d.jpg";